import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
  createSelector
} from '@reduxjs/toolkit'
import type { RootState } from '../../store'
import { API_PATH } from '../../constants';
import { IUser, INewUserInfo } from '../../interfaces';
import { http } from '../../utils/config';

const accessToken = localStorage.getItem('accessToken')
  ? localStorage.getItem('accessToken')
  : null

const userAdapter = createEntityAdapter<IUser>({
  selectId: (user) => (user.id)
})

const initialState = userAdapter.getInitialState({
  loading: false,
  userInfo: null,
  accessToken,
  admin: false,
  error: null,
  success: false
})

export const fetchUser = createAsyncThunk('user/fetchUser', async (id: string, { rejectWithValue }) => {
  try {
    const response = await http.post(API_PATH + '/info', { userID: id });

    return response.data;
  } catch (error: any) {
    if (error.response && error.response.data.message) {
      return rejectWithValue(error.response.data.message)
    } else {
      return rejectWithValue(error.message)
    }
  }
})

export const fetchUsers = createAsyncThunk('scenario/fetchUsers', async () => {
  try {
  
    const response = await http.get(API_PATH + "/users");
  
    return response.data;
  } catch (error: any) {
    if (error.response && error.response.data.message) {
      return error.response.data.message
    } else {
      return error.message
    }
  }
})

export const updateUser = createAsyncThunk(
  'scenarios/updateUser',
  async (user: IUser, { rejectWithValue }) => {
    try {
      const response = await http.put(API_PATH + '/info/', { user });
      return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const registerUser = createAsyncThunk(
  'scenarios/register',
  async (user: INewUserInfo, { rejectWithValue }) => {
    try {
  
      const response = await http.post(API_PATH + '/register', user);
      return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    logout: (state) => {
      localStorage.removeItem('accessToken')
      state.loading = false
      state.userInfo = null
      state.accessToken = null
      state.admin = false
      state.error = null
    },
  },
})

export const {
  logout
} = userSlice.actions

export default userSlice.reducer

export const {
  selectAll: selectUser
} = userAdapter.getSelectors((state: RootState) => state.user)

const selectSelf = (state: RootState) => state

export const getUser1 = createSelector(
  selectSelf,
  (state) => state.user.userInfo
)

export const getUser = createSelector(
  selectUser,
  (user: IUser[]) => { 
    return user.map((user: IUser) => {
      return user;
    })
  }
)